module.exports = __webpack_public_path__ + "static/media/az.198dbef3.svg";